import React, { useEffect, useState, useCallback } from "react";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";

const ListSiswa = ({ listSiswa, idJadwalCbt, urlSiswaReporting, urlSiswaReportKU }) => {
    const [click, setClick] = useState(0);

    const setIncrementClick = useCallback(
        async (idSiswa) => {
            setClick(click + 1);

            // excute when click == 10
            if (click === 3) {
                await accountManagement
                    .get(CONFIG_DEV.CHECK_PSEP_MERAH_SISWA_SELESAI, {
                        params: {
                            idSiswa: idSiswa,
                            idJadwalCbt: idJadwalCbt,
                        },
                    })
                    .then((response) => {
                        if (response.data.data !== " || ") {
                            alert(response.data.data);
                        }
                    })
                    .catch(function (error) {
                        console.error("Error Response Page Eight", error);
                    });
                setClick(0);
            }
        },
        [click]
    );

    return (
        <table className="table table-stripped">
            <thead>
                <th width="5%">No</th>
                <th>Nama</th>
                <th width="10%">Reporting</th>
                {/* <th width="10%">Report KU</th> */}
            </thead>
            <tbody>
                {listSiswa.map((siswa, i) => (
                    <tr>
                        <td>
                            {i + 1}
                            <a href="javascript:void(0)" onClick={() => setIncrementClick(siswa.idSiswa)}>
                                .
                            </a>
                        </td>
                        <td>{siswa.namaSiswa}</td>
                        <td>
                            {siswa.statusAkademik && siswa.statusNonAkademik ? (
                                <a className="btn btn-info" title="Report siswa" href={urlSiswaReporting + idJadwalCbt + "/" + siswa.idSiswa} target="_blank">
                                    <li className="fa fa-print"></li>
                                </a>
                            ) : (
                                <button className="btn btn-danger" title="Belum selesai" aria-hidden="true">
                                    <li className="fa fa-eye-slash"></li>
                                </button>
                            )}
                        </td>
                        {/* <td>
              {siswa.statusAkademik && siswa.statusNonAkademik ? (
                <a className="btn btn-primary" title="Report siswa" href={urlSiswaReportKU + siswa.idSiswa + "/" + idJadwalCbt} target="_blank">
                  <li className="fa fa-print"></li>
                </a>
              ) : (
                <button className="btn btn-danger" title="Belum selesai" aria-hidden="true">
                  <li className="fa fa-eye-slash"></li>
                </button>
              )}
            </td> */}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default ListSiswa;
